<template>
  <div class="details">
    <h2>{{newInfo.title}}</h2>
    <el-row type="flex">
      <!-- <el-col :span="4">作者：管理员</el-col>
      <el-col :span="4">来源：本站</el-col> -->
      <el-col :span="4">时间：{{newInfo.createTime}}</el-col>
    </el-row>
    <div class="new-detail-line"></div>
    <div class="mt-5">
      <p v-html="newInfo.content"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailsNew',
  props: {
    newInfo: {
      type: Object,
      default: {}
    }
  },
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import '@/style/variables.scss';

.details {
  text-align: left;
  h2 {
    margin-top: 0;
    margin-bottom: 1rem;
    text-align: center;
  }
  .new-detail-line {
    margin: 10px 0;
    height: 1px;
    background-color: $textGrey;
  }
}
@media (max-width: 768px) {
  .details>>>img {
    width: 100% !important;
    height: 100% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/detailsNew.vue